import { Component, OnInit } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import {IAfterGuiAttachedParams, ICellRendererParams} from 'ag-grid-community';


@Component({
    selector: 'app-star-rating-renderer',
    templateUrl: './star-rating-renderer.component.html',
    styleUrls: ['./star-rating-renderer.component.css'],
    standalone: false
})
export class StarRatingRendererComponent implements AgRendererComponent, OnInit {

  params: any;

  refresh(params: any): boolean {
    return false;
  }
  agInit(params: ICellRendererParams): void {
    this.params = params;
  }
  afterGuiAttached?(params?: IAfterGuiAttachedParams): void {
    throw new Error('Method not implemented.');
  }

  constructor() { }

  ngOnInit() {
  }

}
